<template>
  <div style="padding:5px">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke elevation-1" style="height:50px;">
            <v-toolbar-title style="padding-bottom:15px">
              <h3>{{getString('Lista esercenti')}}</h3>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <div
                  style="display:inline-block;width:20px;height:20px;border:solid 2px #999;margin-bottom:10px;"
                  class="q-disabled-bk"
                >
                  <span style="margin-left:25px">{{getString('Scaduti')}}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-btn class="q-orange-bk q-text-whitesmoke" @click="getOwners">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-flex xs12 lg12>
                <v-text-field
                  type="text"
                  v-model="search"
                  :label="getString('Filtra')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
            </v-layout>
            <h3>
              {{getString('Totale Esercenti: ')}}
              <b>{{owners.length}}</b>
              {{getString(' - Con negozi scaduti: ')}}
              <b>{{expiredShops}}</b>
              {{getString(' - Con negozi in scadenza: ')}}
              <b>{{expiringShops}}</b>
            </h3>
            <v-data-table
              :headers="Headers"
              :items="owners"
              item-key="idUser"
              :search="search"
              :rows-per-page-items="[10,25,50,100,{text:getString('Tutto'),value:-1}]"
              :rows-per-page-text="getString('Negozi per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="loading"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr
                  style="max-height:100px;overflow:hidden;cursor:pointer"
                  :class="{ 'q-disabled-bk' : props.item.expired > 0, 'q-text-whitesmoke' : props.item.expired > 0 }"
                  v-if="showDisabled !== undefined ? true : props.item.active === 'Attivo' || props.item.active === 'Accettazione'"
                >
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >{{props.item.idUser}}</td>
                   <td class="text-xs-center">
                    <v-btn flat @click="callSamFisher(props.item)">
                      <v-icon :class="{ 'q-text-whitesmoke' : props.item.expired > 0 }">fingerprint</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item.photo)" />
                    </v-list-tile-avatar>
                  </td>
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >{{props.item.name}}</td>
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >{{props.item.surname}}</td>
                  <td class="text-xs-left">{{props.item.email}}</td>
                  <td class="text-xs-left">{{props.item.phone}}</td>
                  <td class="text-xs-left">{{props.item.ownedShops}}</td>
                  <td class="text-xs-left">{{props.item.expired}}</td>
                  <td class="text-xs-left">{{props.item.expiring}}</td>
                  <td class="text-xs-left">{{props.item.active}}</td>
                 
                  <!-- <td class="text-xs-center">
                                    <v-btn flat @click="selectNewDialog(props.item)">
                                        <v-icon :class="{ 'q-text-whitesmoke' : props.item.expired > 0 }">store</v-icon>
                                    </v-btn>
                  </td>-->
                  <td class="text-xs-center" @click="getCredentials(props.item)">
                    <v-btn flat>
                      <v-icon :class="{ 'q-text-whitesmoke' : props.item.expired > 0 }">credit_card</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="selectDlc(props.item)">
                      <v-icon
                        :class="{ 'q-text-whitesmoke' : props.item.expired > 0 }"
                      >move_to_inbox</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat>
                      <v-icon
                        :class="{ 'q-text-whitesmoke' : props.item.expired > 0 }"
                      >remove_circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat>
                  <v-card-title>
                    <h2 class="q-orange">{{props.item.name}}</h2>
                  </v-card-title>
                  <v-card-text>
                    <label>Desc</label>
                    <p>{{props.item.description}}</p>
                    <label>Facebook Link</label>
                    <p>{{props.item.facebookLink}}</p>
                    <label>Instagram Link</label>
                    <p>{{props.item.instagramLink}}</p>
                    <label>Web Link</label>
                    <p>{{props.item.webSiteLink}}</p>
                    <label>Building state</label>
                    <p>{{props.item.isBuilding === true ? getString('Costruzione') : 'No'}}</p>
                  </v-card-text>
                </v-card>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn-toggle class="q-orange-bk" v-model="showDisabled" style="margin-left:10px;">
              <v-btn
                flat
                class="q-text-whitesmoke"
              >{{ showDisabled !== undefined ? getString('Nascondi ') : getString('Mostra ')}}{{getString('Disattivati')}}</v-btn>
            </v-btn-toggle>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dlcDialog" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >{{getString('DLC')+ " "+ selectedUser.name + " " + selectedUser.surname}}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="HeadersDlc"
            :items="currDlcItems"
            :rows-per-page-items="[10,25,{text:getString('Tutto'),value:-1}]"
            :rows-per-page-text="getString('Prenotazioni per pagina')"
            :no-data-text="getString('Dati non disponibili')"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr
                :class="{ 'q-disabled-bk' : isMyDlc(props.item) === false , 'q-text-whitesmoke' : props.item.expired > 0 }"
              >
                <td class="text-xs-left">{{props.item.idDlc}}</td>
                <td class="text-xs-left">{{props.item.dlc}}</td>
                <td class="text-xs-left">{{props.item.comment}}</td>
                <td class="text-xs-center">
                  <v-btn flat v-show="!isMyDlc(props.item)" @click="enableDlc(props.item.dlc)">
                    <v-icon>move_to_inbox</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-center">
                  <v-btn flat v-show="isMyDlc(props.item)" @click="disableDlc(props.item.dlc)">
                    <v-icon>move_to_inbox</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="dlcDialog = false">{{getString('Chiudi')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ajax from "../../../ajax";
import Utils from "../../../utils";
var ut = new Utils();
export default {
  name: "AdminOwners",
  mounted: function() {
    this.init();
  },
  computed: {
    expiringShops: function() {
      let i = 0;
      this.owners.forEach(e => {
        if (e.expiring > 0) {
          i++;
        }
      });
      return i;
    },
    expiredShops: function() {
      let i = 0;
      this.owners.forEach(e => {
        if (e.expired > 0) {
          i++;
        }
      });
      return i;
    },
    notEmpty: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    emailRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    numRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v =>
          ut.ValidateNumber(v) ||
          this.getString("Numero non valido, torniamo a scuola per cortesia?")
      ];
    },
    locale: function() {
      return this.$store.state.currentTranslator.locale;
    },
    HeadersDlc: function() {
      let result = [];
      let self = this;
      if (this.currDlcItems.length > 0) {
        let temp = [
          self.getString("Id"),
          self.getString("Dlc"),
          self.getString("Commento"),
          self.getString("Assegna"),
          self.getString("Disassegna")
        ];
        temp.forEach(element => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: "left",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1]
          });
        });
        return result;
      }
      return [];
    },
    Headers: function() {
      let result = [];
      let self = this;
      if (this.owners.length > 0) {
        let temp = [
          self.getString("Id:idUser"),
          self.getString("4Echelon"),
          self.getString("Foto:image"),
          self.getString("Nome:name"),
          self.getString("Cognome:surname"),
          self.getString("Email:email"),
          self.getString("Telefono:phone"),
          self.getString("Numero negozi:ownedShops"),
          self.getString("Scaduti:expired"),
          self.getString("In scadenza:expiring"),
          self.getString("Stato:active"),
          // self.getString('Nuovo negozio'),
          self.getString("Reinvia credenziali"),
          self.getString("DLC"),
          self.getString("Disabilita")
        ];
        temp.forEach(element => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: element.split(":").length > 1 ? "left" : "center",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1]
          });
        });
        return result;
      }
      return [];
    }
  },
  data: () => {
    return {
      h: null,
      currDlcItems: [],
      myDlcItems: [],
      dlcDialog: false,
      active: null,
      showDisabled: undefined,
      owners: [],
      search: null,
      loading: false,
      selectedUser: {},
      noteDialog: false,
      currNote: "",
      dialogCost: 0,
      dialogDateMenu: false,
      dialogNote: "",
      dialogCheck: false,
      dialogCheck1: false,
      dialogDate:
        new Date().getFullYear() +
        "-" +
        ut.NumberWith0(new Date().getMonth() + 1) +
        "-" +
        ut.NumberWith0(1),
      newDialog: false,
      nameShopNewDialog: "",
      addressNewDialog: "",
      cityNewDialog: "",
      provNewDialog: "",
      capNewDialog: "",
      geoNewDialog: "",
      noteNewDialog: ""
    };
  },
  methods: {
    callSamFisher: function(item) {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/samfisher/" + item.idUser + "/name/" + item.name, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.$store.commit("setfakeUser", response.data.data.token);
          self.$emit("siteAlertSuccess", response.data.data.message);
          self.$emit("refreshShops");
          self.$router.push('/admin/dashboard')
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    defaultAvatar: function(url) {
      if (
        url === null ||
        url === "images/u_placeholder.jpg" ||
        url === "/images/u_placeholder.jpg"
      ) {
        return (
          "/../../../../static/img/default-avatar.png"
        );
      } else return ajax.baseUrl() + url;
    },
    selectNewDialog: function(item) {
      this.selectedUser = item;
      this.newDialog = true;
    },
    selectDlc: function(item) {
      this.selectedUser = item;
      this.currDlcItems = [];
      this.myDlcItems = [];
      this.getDlc();
      this.dlcDialog = true;
    },
    resetNewDialog: function() {
      this.nameShopNewDialog = "";
      this.addressNewDialog = "";
      this.cityNewDialog = "";
      this.provNewDialog = "";
      this.capNewDialog = "";
      this.geoNewDialog = "";
      this.noteNewDialog = "";
      this.newDialog = false;
    },
    newShop: function() {
      let self = this;
      var data = new FormData();
      data.append("shopName", self.nameShopNewDialog);
      data.append("address", self.addressNewDialog);
      data.append("city", self.cityNewDialog);
      data.append("prov", self.provNewDialog);
      data.append("cap", self.capNewDialog);
      data.append("lat", self.geoNewDialog.split(";")[0]);
      data.append("lon", self.geoNewDialog.split(";")[1]);
      data.append("note", self.noteNewDialog);
      data.append("demo", self.dialogCheck1);
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/man/owner/" +
            self.selectedUser.idUser +
            "/shop",
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + self.$store.getters.token
            },
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.resetNewDialog();
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    init: function() {
      this.getOwners();
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    enableShop: function(shop) {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/man/enableshop/" + shop.idBarberShop,
          {
            enable: !shop.isActive
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.loading = false;
          shop.isActive = !shop.isActive;
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getCredentials: function(item) {
      let self = this;
      this.selectedUser = item;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/owner/" + item.idUser + "/sendpwd", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getOwners: function() {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/getowners", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          let temp = response.data.data;
          self.loading = false;
          for (let index = 0; index < temp.length; index++) {
            let element = temp[index];
            if (element.active === 0) {
              element.active = self.getString("Disattivato");
            }
            if (element.active === 1) {
              element.active = self.getString("Attivo");
            }
            if (element.active === 2) {
              element.active = self.getString("Accettazione");
            }
          }
          self.owners = temp;
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    isMyDlc: function(item) {
      return this.myDlcItems.filter(x => x.dlc === item.dlc).length > 0;
    },
    getDlc: function() {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(
          ajax.baseUrl() + "/admin/man/getAllDlc/" + this.selectedUser.idUser,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          let temp = response.data.data;
          self.loading = false;
          self.currDlcItems = temp.all;
          self.myDlcItems = temp.my;
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    enableDlc: function(id) {
      let self = this;
      this.loading = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/man/dlc/enable/" +
            id +
            "/owner/" +
            this.selectedUser.idUser,
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.getDlc();
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    disableDlc: function(id) {
      let self = this;
      this.loading = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/man/dlc/disable/" +
            id +
            "/owner/" +
            this.selectedUser.idUser,
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.getDlc();
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    }
  }
};
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/AdminOwners.vue